(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-thumbs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('azv-thumbs')) {
    customElements.define('azv-thumbs', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.azv-track');
        this.prev = this.querySelector('.azv-nav--prev');
        this.next = this.querySelector('.azv-nav--next');
        if (!this.track) return;
        const step = () => Math.max(this.track.clientWidth * 0.8, 60);
        this.prev.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.track.scrollBy({ left: -step() }); });
        this.next.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.track.scrollBy({ left: step() }); });
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.prev.hidden = this.track.scrollLeft <= 2;
          this.next.hidden = this.track.scrollLeft >= max;
        };
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this.track);
        this.update();
      }
      disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
